<section class="manage-filters-section">
    <div class="header"> 
        <h4 *ngIf="payload.isManageTitle" class="manage-filter">{{payload.title | stringTranslate}}</h4>
        <div *ngIf="!payload.isManageTitle" class="save-filter">{{'Do you want to save the' | stringTranslate }} {{payload.resourceTitle?.toLowerCase()}} as
          <input type="text" class="filter-name" [(ngModel)]="selectedFilter" id="saveManagedFilter"
          (ngModelChange)="updateButtonStatus($event)"/>?
        </div>
    </div>
    <div *ngIf="payload.filters.length == 0 && payload.isManageDialog" class="dynamic-modal-content">{{'There are no saved' | stringTranslate}} {{payload.resourceTitle == 'Settings' ? 'settings' : payload.resourceTitle?.toLowerCase() + 's' | stringTranslate}}
    </div>
    <div *ngIf="payload.filters.length > 0 && payload.isManageDialog" class="manage-filters-list">      
        <div class="Flexbox header table-header">
            <div>{{payload.resourceTitle}} name</div>
            <div>Creation date</div>
        </div>
        <div class="manage-list-content">  
            <section 
                class="list-single-item pointer"
       
                *ngFor="let filter of payload.filters; index as i">              
                <gen-dynamic-form
                    class="form-wrapper"
                    [editMode]="true"
                    [formData]="filter"
                    [formName]="'managed-filters'"
                    [formConfig]="dynamicFormConfig"
                    [disabled]="filter.undeletable"
                    (formChange)="updateForm(i, $event.form)"
                    [ngStyle]="!filter.undeletable && {'width': 'calc(100% - 50px)'}"
                >

                </gen-dynamic-form>
                <gen-button
                    *ngIf = "!filter.undeletable"
                    class="delete-btn"
                    [type]="'quite'"
                    [iconClass]="'icon__cross'" 
                    (click)="deleteManagedFilter(i, $event)" 
                ></gen-button>
            </section>
        </div>
    </div> 
</section>